<template>
	<div class="improcing layui-layout layui-layout-admin">
		<div class="layui-header zt_color layui-row f_row al_itm jc_ct">
			<div class="px24" style="color:#fff;">完善资料</div>
		</div>
		<div class="layui-form px16" action="">
			<table class="layui-table bge" style="width:48%;margin: 50px 0 0 26%;">
				<colgroup>
					<col width="15%">
					<col width="20%">
					<col width="15%">
					<col width="15%">
					<col width="15%">
				</colgroup>
				<tbody class="align_center px16">
					<tr>
						<td class="ft_wt">公司名称</td>
						<td>
							<input type="text" name="names" maxlength="20" lay-reqText="请输入公司名称" lay-verify="required">
						</td>
						<td class="ft_wt">注册资本</td>
						<td colspan="2">
							<input type="text" name="sex" lay-reqText="请输入注册资本" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">法定代表人</td>
						<td>
							<input type="text" name="borths" lay-reqText="请输入法定代表人" lay-verify="required">
						</td>
						<td class="ft_wt">民族</td>
						<td colspan="2">
							<div style="display: flex;">
								<div><input type="text" name="clas" lay-reqText="请输入民族" lay-verify="required" style="text-align: right;"></div>
								<div style="width: 50px;margin-left: 5px;">族</div>
							</div>
							<!-- <input type="text" name="clas"  lay-reqText="请输入民族" lay-verify="required"> -->
						</td>
					</tr>
					<tr>
						<td class="ft_wt">联系电话</td>
						<td>
							<input type="phone" name="phone" maxlength="11" lay-reqText="请输入联系电话" lay-verify="phone">
						</td>
						<td class="ft_wt">从业年限</td>
						<td colspan="2">
							<div style="display: flex;">
								<div><input type="text" name="times" lay-reqText="请输入从业年限" lay-verify="required|number" style="text-align: right;"></div>
								<div style="width: 50px;margin-left: 5px;">年</div>
							</div>
							<!-- <input type="text" name="times"  lay-reqText="请输入从业年限" lay-verify="required"> -->
						</td>
					</tr>
					<tr>
						<td class="ft_wt">合作意向</td>
						<td>
							<div class="f_row al_itm jc_ct">
								<div @click="setIndex(1)" class="f_row al_itm pointer">
									<i v-show="clasIndex==1" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
									<i v-show="clasIndex!=1" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
									<span>&nbsp;全职</span>
								</div>
								<div @click="setIndex(2)" class="f_row al_itm pointer" style="margin-left:10px;">
									<i v-show="clasIndex==2" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
									<i v-show="clasIndex!=2" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
									<span>&nbsp;兼职</span>
								</div>
							</div>
						</td>
						<td class="ft_wt">QQ</td>
						<td colspan="2">
							<input type="text" name="qq" maxlength="15" lay-reqText="请输入QQ" lay-verify="required|number">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">银行卡号</td>
						<td colspan="4">
							<input type="text" name="cards" maxlength="20" lay-reqText="请输入银行卡号" lay-verify="required|number">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">注册地址</td>
						<td colspan="4">
							<input type="text" name="address" maxlength="30" lay-reqText="请输入注册地址" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt">工作邮箱</td>
						<td>
							<input type="email" name="email" maxlength="30" lay-reqText="请输入工作邮箱" lay-verify="email">
						</td>
						<td class="ft_wt">员工人数</td>
						<td colspan="2">
							<input type="text" name="nowAdds" maxlength="8" lay-reqText="请输入员工人数" lay-verify="required">
						</td>
					</tr>
					<tr>
						<td class="ft_wt" rowspan="6">激光切割机明细</td>
						<td class="ft_wt">设备</td>
						<td class="ft_wt">型号</td>
						<td class="ft_wt">设备每月产能</td>
						<td class="ft_wt">每月意向接单数量</td>
					</tr>
					<tr v-for="(item,i) in expList" :key="i">
						<td>
							<input type="text" v-model="item.a" :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
						<td>
							<input type="text" v-model="item.b" :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
						<td>
							<input type="text" v-model="item.c" :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
						<td>
							<input type="text" v-model="item.d" :disabled="i > 0 && (expList[i-1].a == '' || expList[i-1].b == '' || expList[i-1].c == '' || expList[i-1].d == '')  ? true : false">
						</td>
					</tr>
					<tr style="border-bottom: 1px solid #000;">
						<td class="ft_wt" >选择地址</td>
						<td colspan="4" style="position: relative;">
							<div id="baiduMap" style="height: 400px;"></div>
							<div style="position: absolute;top: 10px;left: 10px;z-index: 888;">
								<input type="text" id="suggestId" placeholder="搜索" class="layui-input" style="width: 200px;height: 30px;text-align: left;">
								<div id="searchResultPanel" style="display: none;"></div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<button type="button" class="layui-btn zt_color px16" lay-submit lay-filter="impros" style="width:30%;margin: 50px 0 50px 35%;">提交注册</button>
		</div>
		<div class="layui-footer align_center zt_color f_row al_itm jc_ct" style="left:0;color:#fff;">
			<span>© 桃琼之瑶SMT活动钢网</span>
		</div>
		<div v-show="showOks" class="rgstOk f_col al_itm jc_ct">
			<i class="layui-icon layui-icon-ok-circle zt_txt_color px200"></i>
			<span class="px24">注册成功!</span>
			<span @click="goHomes" class="px16 zt_txt_color d_line pointer">{{times}}S后跳转</span>
		</div>
		<div id="qrCode" style="display: none;">
			<img src="../assets/qrcode.png" />
			<p>亲爱的，请打开手机微信扫描上图二维码，关注我们的公众号并且选择绑定。您将及时收到我们平台给您推送的订单实时信息，桃琼之瑶为您助力。假如您不绑定我们的公众号，给您带来的不便及损失，平台将不承担相关责任</p>
			<button class="layui-btn zt_color" style="display: block;margin: 20px auto 0;" @click="onClose">已关注</button>
		</div>
	</div>
</template>

<script>
	var map = '';
	export default {
		name: 'login',
		data() {
			return {
				forms: '',
				times: 3,
				showOks: false,
				clasIndex: 1,
				expList: [{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					},
					{
						a: '',
						b: '',
						c: '',
						d: ''
					}
				],
				lng: '',
				lat: ''
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			this.createMap();
			layui.use(['form', 'layer'], () => {
				this.forms = layui.form;
				var layer = layui.layer;
				this.forms.on('submit(impros)', (e) => {
					console.log('提交表单', e);
					let t = 0;
					let cutting = [];
					this.expList.forEach((val) => {
						if(val.a != '' && val.b != '' && val.c != '' && val.d != '') {
							t += 1;
						}
					})
					if(t != 0) {
						if(t < 5 && (_this.expList[t].a != '' || _this.expList[t].b != '' || _this.expList[t].c != '' || _this.expList[t].d != '')) {
							layer.msg('请完善激光切割明细表', {
								icon: 2,
								anim: 6
							});
							return false;
						}
						if(_this.lat == '' || _this.lng == '') {
							layer.msg('请在地图上选择注册地址', {
								icon: 2,
								anim: 6
							});
							return false;
						}
						for(let i = 0; i < t; i++) {
							let obj = {};
							obj.equipment = _this.expList[i].a;
							obj.model = _this.expList[i].b;
							obj.capacity = _this.expList[i].c;
							obj.num = _this.expList[i].d;
							cutting.push(obj);
						}
						api.fillInfo({
							token: this.getCookie('token'),
							corporate_name: e.field.names,
							registered_capital: e.field.sex,
							legal_representative: e.field.borths,
							nation: e.field.clas,
							moblie: e.field.phone,
							working_life: e.field.times,
							cooperation: _this.clasIndex,
							bank_account: e.field.cards,
							qq: e.field.qq,
							registration_address: e.field.address,
							email: e.field.email,
							staff_num: e.field.nowAdds,
							laser_cutting_machine: JSON.stringify(cutting),
							lat: _this.lat,
							lng:_this.lng
						}).then((res) => {
							if(res.code == 1) {
								layer.open({
									title: '',
									type: 1,
									content: $('#qrCode'),
									shade: 0.3,
									cancel: function(index, layero) {
										_this.showOks = true;
										let jshi = setInterval(() => {
											if(_this.times >= 1) {
												_this.times = _this.times - 1
											} else {
												clearInterval(jshi);
												_this.$router.replace('login');
											}
										}, 1000)
									}
								});
							} else {
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								});
							}
						})
					} else {
						layer.msg('至少填写一条激光切割机明细', {
							icon: 2,
							anim: 6
						});
					}
				});
				this.forms.render();
			});
		},
		methods: {
			createMap() {
				let _this = this;
				map = new BMap.Map("baiduMap", {
					enableMapClick: false
				});
				map.centerAndZoom('深圳', 12); // 创建点坐标,初始化地图,设置中心点坐标和地图级别
				map.addControl(new BMap.ScaleControl({
					anchor: BMAP_ANCHOR_BOTTOM_LEFT
				}));
				map.addControl(new BMap.NavigationControl({
					anchor: BMAP_ANCHOR_BOTTOM_RIGHT
				}));
				map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
				map.enableInertialDragging(); //两秒后开启惯性拖拽
				map.addEventListener("click", function(e) { //单击地图事件
					_this.lng = e.point.lng;
					_this.lat = e.point.lat;
					let point = new BMap.Point(e.point.lng, e.point.lat);
					let marker = new BMap.Marker(point);
					map.clearOverlays();
					map.addOverlay(marker);
				});

				var ac = new BMap.Autocomplete({
					"input": "suggestId",
					"location": map
				});
				ac.addEventListener("onhighlight", function(e) { //鼠标放在下拉列表上的事件
					var str = "";
					var _value = e.fromitem.value;
					var value = "";
					if(e.fromitem.index > -1) {
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
					value = "";
					if(e.toitem.index > -1) {
						_value = e.toitem.value;
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					document.getElementById("searchResultPanel").innerHTML = str;
				});

				var myValue;
				ac.addEventListener("onconfirm", function(e) { //鼠标点击下拉列表后的事件
					var _value = e.item.value;
					myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
					document.getElementById("searchResultPanel").innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
					setPlace();
				});

				function setPlace() {
					map.clearOverlays(); //清除地图上所有覆盖物
					function myFun() {
						var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
						_this.lng = pp.lng;
						_this.lat = pp.lat;
						map.centerAndZoom(pp, 18);
						map.addOverlay(new BMap.Marker(pp)); //添加标注
					}
					var local = new BMap.LocalSearch(map, { //智能搜索
						onSearchComplete: myFun
					});
					local.search(myValue);
				}
			},
			theLocation(val) {
				map.centerAndZoom(val, 11);
			},
			setIndex(i) {
				this.clasIndex = i;
			},
			goHomes() {
				this.$router.replace('login');
			},
			onClose() {
				let _this = this;
				this.showOks = true;
				layer.closeAll();
				let jshi = setInterval(() => {
					if(_this.times >= 1) {
						_this.times = _this.times - 1
					} else {
						clearInterval(jshi);
						_this.$router.replace('login');
					}
				}, 1000)
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.layui-table tbody tr:hover,
	.layui-table thead tr,
	.layui-table-click,
	.layui-table-header,
	.layui-table-hover,
	.layui-table-mend,
	.layui-table-patch,
	.layui-table-tool,
	.layui-table[lay-even] tr:nth-child(even) {
		background-color: transparent;
	}
	
	.rgstOk {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 99999;
	}
	
	.requires::before {
		content: url('../assets/require.png');
		width: 20px;
		height: 20px;
		position: absolute;
		top: 50%;
		margin-top: -10px;
		left: -24px;
	}
	
	.bge td {
		line-height: 45px;
		min-height: 45px;
		padding: 0;
		border-width: 1px;
		border-color: #000;
		position: inherit;
	}
	
	.bge input {
		width: 100%;
		text-align: center;
		display: block;
		height: 45px;
		border: none;
	}
	
	#qrCode {
		width: 300px;
		padding: 20px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 10px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
		color: #FF494C;
	}
</style>


// WEBPACK FOOTER //
// src/components/improving.vue